/**
 * PrimitiveRegistryPage - Universal primitive registry dashboard
 *
 * Surfaces the UniversalPrimitiveRegistryDashboard from @ferp/workflow-forms for architect users.
 * Provides a registry view of all 25 primitives with their configurations.
 *
 * Route: /admin/primitive-registry
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconDatabase } from '@tabler/icons-react';

import { UniversalPrimitiveRegistryDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function PrimitiveRegistryPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="teal">
            <IconDatabase size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Primitive Registry</Title>
            <Text size="sm" c="dimmed">
              Registry view of all 25 primitives with their configurations
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <UniversalPrimitiveRegistryDashboard tenant={tenant?.id ?? ''} />
    </Container>
  );
}

export default PrimitiveRegistryPage;
